import React from 'react';
import { Preloader } from 'react-materialize';

export default () => {
    return(<Preloader flashing/>
    )
}
